import React from 'react'
import {
  affiliateInfo,
  AFFILIATE_APPLICATION_FORM_URL,
} from '../constants/affiliate'
import { BaseLayout } from '../layout'
import { APPLICATION_MAX_WIDTH } from '../constants'
import woman_on_laptop from '../assets/woman_on_laptop.png'
import { Box, Flex, Heading, Image, Text } from '@chakra-ui/react'
import { FAQs, FullColourLogo, Link, Metadata } from '../components'
import happy_man_with_laptop from '../assets/happy-man-with-laptop.png'

export const AffiliatePage: React.FC = () => {
  const commisionFee = 10

  return (
    <BaseLayout data-testid='affiliate-page' fullWidth>
      <Metadata
        title="Affilate Register | Dot Campus"
        description={`Refer learners and earn ${commisionFee}% commission fee.`}
      />
      {/* Logo */}
      <Box
        width="full"
        padding="5"
        data-testid="logo"
        maxWidth={APPLICATION_MAX_WIDTH}
        marginX="auto"
      >
        <Flex alignItems="center">
          <FullColourLogo />
        </Flex>
      </Box>
      {/* Main Content */}
      <Box
        as="main"
        width="100%"
        maxWidth={APPLICATION_MAX_WIDTH}
        margin="auto"
      >
        <Box as="section" pt={{base: '8', md: 0}} pb='8' paddingX="8">
          <Flex gap={10} alignItems="center" justifyContent="space-between">
            <Box textAlign={{ base: 'center', md: 'left' }}>
              <Heading data-testid='page-heading' as="h2" fontSize="3xl">
                Become our affiliate
              </Heading>
              <Text pt="1">
                With the DotCampus Affiliate Program, you can refer learners to
                our courses and <strong>earn a 10% commission</strong> on every
                successful enrollment through your unique link!
              </Text>
              <Box mt={{ base: '10', md: '12' }}>
                <Link
                  px='6'
                  fontSize='md'
                  color="white"
                  minWidth="165px"
                  borderRadius="12px"
                  fontWeight="medium"
                  textDecoration="none"
                  bgColor="orange.400"
                  py={{base: '3', lg: '4'}}
                  to={AFFILIATE_APPLICATION_FORM_URL}
                  _hover={{ textDecoration: 'none', bgColor: 'orange.800' }}
                >
                  Become Our Affiliate
                </Link>
              </Box>
            </Box>
            <Box display={{ base: 'none', md: 'block' }} width="100%">
              <Image
                borderRadius={6}
                src={woman_on_laptop}
                alt="An affiliate using her lapotop to refer learners to Dot Campus"
              />
            </Box>
          </Flex>
        </Box>
        <Box
          as="section"
          position="relative"
          backgroundSize="cover"
          backgroundPosition="center"
          backgroundImage={happy_man_with_laptop}
          paddingX={{ base: '8', md: '14', lg: '28' }}
          paddingY={{ base: '12', md: '24', lg: '36' }}
        >
          {/* Blurred Black Overlay */}
          <Box
            inset="0"
            position="absolute"
            backdropFilter="blur(10px)"
            backgroundColor="blackAlpha.500"
          />
            <Box
              color="black"
              rounded="2xl"
              position="relative"
              backdropFilter="blur(20px)"
              backgroundColor="whiteAlpha.900"
              paddingX={{ base: '6', md: '8' }}
              paddingY={{ base: '6', md: '12' }}
            >
              <Heading as="h3">What you&apos;ll get?</Heading>
              <Text width={{ md: '65%' }}>
                As an affiliate in our Affiliate Program, you&apos;ll enjoy a suite of benefits
                designed to make your partnership with us both rewarding and enjoyable.
              </Text>
              <Flex
                py="8"
                gap={{ base: '4', md: '6' }}
                flexDirection={{ base: 'column', md: 'row' }}
              >
                <Box width="100%">
                  <Heading as="h4" pb="1">Commission Rate</Heading>
                  <Text>
                    Earn an attractive {commisionFee}% commission on every course purchase made
                    through your referral link.
                    <strong>The more you promote, the more you earn!</strong>
                  </Text>
                </Box>
                <Box width="100%">
                  <Heading as="h4" pb="1">Promotion Method</Heading>
                  <Text>
                    Upon signing up, you&apos;ll receive a unique affiliate link.
                    Every new learner through your link will be credited to you.
                  </Text>
                </Box>
                <Box width="100%">
                  <Heading as="h4" pb="1">Commission Payouts</Heading>
                  <Text>
                    Get paid seamlessly via PayPal or Bank Transfer—no hassle,
                    just rewards for your efforts!
                  </Text>
                </Box>
              </Flex>
            </Box>
          </Box>
        <FAQs items={affiliateInfo} />
      </Box>
    </BaseLayout>
  )
}
